import { LinkBox } from "../components/LinkBox";
import { Header } from "../components/Header";
import styled from 'styled-components'
import { theme } from "../theme";
import { Search, PersonPinRounded, CheckCircle, UploadFile, Photo, AdminPanelSettings, Download } from '@mui/icons-material';
import { Link } from "../components/Link";
import { useEffect } from "react";
import { authenticator } from "../services/Authenticator";
import { useNavigate } from "react-router-dom";
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: ${theme.spacing.md};
`

export function Home() {
  const navigate = useNavigate()

  async function redirectToLoginScreenIfNotLoggedIn() {
    // const user = await authenticator.getLoggedInUser()
    // console.log('user',user)
    // if (!user) {
    //   // navigate('/Login')
    // }
    firebase.auth().onAuthStateChanged(function(user) {
      if (!user) {
        navigate('/Login')
      } 
    })
  }

  useEffect(() => {
    redirectToLoginScreenIfNotLoggedIn()
  }, [])

  return (
    <>
      <Header />

      <ButtonContainer>
        <Link to="/new-patient-form">
          <LinkBox title={<>New Patient Forms</>} icon={<CheckCircle fontSize={'large'} />} />
        </Link>
        <Link to="/file-upload">
          <LinkBox title={<>Upload File</>} icon={<UploadFile fontSize={'large'} />} />
        </Link>
        {/* <LinkBox title={<>SmileDentist Patients</>} icon={<PersonPinRounded fontSize={'large'} />} />
        <LinkBox title={<>Patient<br/>Tracker</>} icon={<PersonPinRounded fontSize={'large'} />} />
        <LinkBox title={<>Completed Forms</>} icon={<CheckCircle fontSize={'large'} />} />
        <LinkBox title={<>SmileDentist<br/>Galleries</>} icon={<Photo fontSize={'large'} />} /> */}
      </ButtonContainer>

      <ButtonContainer>
      {/* <LinkBox title={<>Data<br/>Backups</>} icon={<Download fontSize={'large'} />} />
      <LinkBox title={<>Master Admin Controls</>} icon={<AdminPanelSettings fontSize={'large'} />} /> */}
      </ButtonContainer>

    </>
  )
}